import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-clock',
  imports: [],
  templateUrl: './clock.html',
  styleUrl: './clock.scss',
})
export class Clock {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
